import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Zap, Clock, MessageSquare, ShieldAlert, Package
} from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { useAuth } from '../contexts/AuthContext';

// Store staff roles that can use Quick Actions
const STORE_STAFF_ROLES = [
  'store_manager',
  'assistant_manager', 
  'grocery_staff',
  'checkout_staff',
  'staff',
  'casual'
];

const QUICK_ACTIONS = [
  {
    id: 'expiry',
    label: 'Expiry',
    icon: Clock,
    path: '/expiry-report',
    gradient: 'from-orange-500 to-red-500',
    shadow: 'shadow-orange-200'
  },
  {
    id: 'feedback',
    label: 'Feedback',
    icon: MessageSquare,
    path: '/feedback/submit',
    gradient: 'from-blue-500 to-indigo-500',
    shadow: 'shadow-blue-200'
  },
  {
    id: 'incident',
    label: 'Incident',
    icon: ShieldAlert,
    path: '/incidents/report',
    gradient: 'from-red-500 to-pink-500',
    shadow: 'shadow-red-200'
  },
  {
    id: 'demand',
    label: 'Demand',
    icon: Package,
    path: '/customer-demand',
    gradient: 'from-green-500 to-emerald-500',
    shadow: 'shadow-green-200'
  }
];

export default function QuickActionWidget() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Only show for store staff roles
  if (!user || !STORE_STAFF_ROLES.includes(user.role)) {
    return null;
  }

  return (
    <Card className="bg-gradient-to-br from-slate-50 to-white border-slate-200" data-testid="quick-action-widget">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <div className="p-1.5 rounded-lg bg-gradient-to-br from-yellow-400 to-orange-500">
            <Zap className="h-4 w-4 text-white" />
          </div>
          Quick Action
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {QUICK_ACTIONS.map((action) => {
            const Icon = action.icon;
            return (
              <button
                key={action.id}
                onClick={() => navigate(action.path)}
                className={`group flex flex-col items-center justify-center p-4 rounded-xl bg-gradient-to-br ${action.gradient} text-white hover:scale-105 transition-all duration-200 ${action.shadow} shadow-lg hover:shadow-xl`}
                data-testid={`quick-widget-${action.id}`}
              >
                <Icon className="h-7 w-7 mb-2 group-hover:scale-110 transition-transform" />
                <span className="font-semibold text-sm">{action.label}</span>
              </button>
            );
          })}
        </div>
        <p className="text-xs text-center text-slate-400 mt-3">
          One-click access to key actions
        </p>
      </CardContent>
    </Card>
  );
}
